import React, { useState } from "react";
import { Row } from "reactstrap";

const EuroConfirmationModal = ({
  data,
  assessmentStarted,
  toggle,
  setAssessmentStarted,
  setisConfirmSetting,
  isConfirmSetting,
  setIsconfirmCondition,
  IsconfirmCondition,
  setIsconfirmAttempt,
  IsconfirmAttempt
}) => {
  const [ShowError, setisShowError] = useState(false);
  return (
    <div className="px-4">
      <div className="d-flex align-items-start">
        <div className="consent-container border-bottom pb-3">
          <div className="consent-item">
            <input
              type="checkbox"
              id="microphoneTest"
              className="consent-checkbox"
              checked={isConfirmSetting}
              onClick={() => {
                setisConfirmSetting(!isConfirmSetting);
                setisShowError(false);
              }}
            />
            <label htmlFor="microphoneTest" className="consent-label mx-1">
              I have tested speakers, internet speed and browser compatibility.
            </label>
          </div>

          <div className="consent-item">
            <input
              type="checkbox"
              id="dataConsent"
              className="consent-checkbox"
              checked={IsconfirmCondition}
              onClick={() => {
                setIsconfirmCondition(!IsconfirmCondition);
                setisShowError(false);
              }}
            />
            <label htmlFor="dataConsent" className="consent-label mx-1">
              I consent to share my data with Eurolingva, Gradingly Limited and
              Prosperity Education and confirm that my data will not be shared
              with third parties in compliance with data protection laws.
            </label>
          </div>
          <div className="consent-item">
            <input
              type="checkbox"
              id="dataConsent"
              className="consent-checkbox"
              checked={IsconfirmAttempt}
              onClick={() => {
                setIsconfirmAttempt(!IsconfirmAttempt);
                setisShowError(false);
              }}
            />
            <label htmlFor="dataConsent" className="consent-label mx-1">
              I understand that this is a single-attempt test: To leave the test
              without completing all questions will result in the test being
              submitted for assessment.
            </label>
          </div>
          {ShowError && (
            <p className="ps-4 pt-2" style={{ color: "red" }}>
              To proceed, please agree to the system requirements
            </p>
          )}
        </div>
      </div>
      <Row className="pt-3 g-0">
        <div
          className={`align-text d-flex ${
            data?.status === "In progress" || assessmentStarted
              ? "justify-content-between"
              : "justify-content-end"
          }`}
        >
          {(data?.status === "In progress" || assessmentStarted) && (
            <button
              type="button"
              className="btn  border-grey me-2"
              onClick={() => {
                toggle();
              }}
            >
              Cancel
            </button>
          )}
          <button
            type="button"
            className="btn btn-warning confirm-button ms-2"
            onClick={() => {
              if (isConfirmSetting && IsconfirmCondition && IsconfirmAttempt) {
                setAssessmentStarted(true);
                toggle();
              } else {
                setisShowError(true);
              }
            }}
          >
            Confirm
          </button>
        </div>
      </Row>
    </div>
  );
};

export default EuroConfirmationModal;
